{
  "name": "pino",
  "version": "7.11.0",
  "description": "super fast, all natural json logger",
  "main": "pino.js",
  "type": "commonjs",
  "types": "pino.d.ts",
  "browser": "./browser.js",
  "files": [
    "pino.js",
    "file.js",
    "pino.d.ts",
    "bin.js",
    "browser.js",
    "pretty.js",
    "usage.txt",
    "test",
    "docs",
    "example.js",
    "lib"
  ],
  "scripts": {
    "docs": "docsify serve",
    "browser-test": "airtap --local 8080 test/browser*test.js",
    "lint": "eslint .",
    "test": "npm run lint && npm run transpile && tap --ts && jest test/jest && npm run test-types",
    "test-ci": "npm run lint && npm run transpile && tap --ts --no-check-coverage --coverage-report=lcovonly && npm run test-types",
    "test-ci-pnpm": "pnpm run lint && npm run transpile && tap --ts --no-coverage --no-check-coverage && pnpm run test-types",
    "test-ci-yarn-pnp": "yarn run lint && npm run transpile && tap --ts --no-check-coverage --coverage-report=lcovonly",
    "test-types": "tsc && tsd && ts-node test/types/pino.ts",
    "transpile": "node ./test/fixtures/ts/transpile.cjs",
    "cov-ui": "tap --ts --coverage-report=html",
    "bench": "node benchmarks/utils/runbench all",
    "bench-basic": "node benchmarks/utils/runbench basic",
    "bench-object": "node benchmarks/utils/runbench object",
    "bench-deep-object": "node benchmarks/utils/runbench deep-object",
    "bench-multi-arg": "node benchmarks/utils/runbench multi-arg",
    "bench-longs-tring": "node benchmarks/utils/runbench long-string",
    "bench-child": "node benchmarks/utils/runbench child",
    "bench-child-child": "node benchmarks/utils/runbench child-child",
    "bench-child-creation": "node benchmarks/utils/runbench child-creation",
    "bench-formatters": "node benchmarks/utils/runbench formatters",
    "update-bench-doc": "node benchmarks/utils/generate-benchmark-doc > docs/benchmarks.md"
  },
  "bin": {
    "pino": "./bin.js"
  },
  "precommit": "test",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/pinojs/pino.git"
  },
  "keywords": [
    "fast",
    "logger",
    "stream",
    "json"
  ],
  "author": "Matteo Collina <hello@matteocollina.com>",
  "contributors": [
    "David Mark Clements <huperekchuno@googlemail.com>",
    "James Sumners <james.sumners@gmail.com>",
    "Thomas Watson Steen <w@tson.dk> (https://twitter.com/wa7son)"
  ],
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/pinojs/pino/issues"
  },
  "homepage": "http://getpino.io",
  "devDependencies": {
    "@types/flush-write-stream": "^1.0.0",
    "@types/node": "^17.0.0",
    "@types/tap": "^15.0.6",
    "airtap": "4.0.4",
    "benchmark": "^2.1.4",
    "bole": "^4.0.0",
    "bunyan": "^1.8.14",
    "docsify-cli": "^4.4.1",
    "eslint": "^7.17.0",
    "eslint-config-standard": "^16.0.3",
    "eslint-plugin-import": "^2.22.1",
    "eslint-plugin-node": "^11.1.0",
    "eslint-plugin-promise": "^5.1.0",
    "execa": "^5.0.0",
    "fastbench": "^1.0.1",
    "flush-write-stream": "^2.0.0",
    "import-fresh": "^3.2.1",
    "jest": "^27.3.1",
    "log": "^6.0.0",
    "loglevel": "^1.6.7",
    "pino-pretty": "^v7.6.0",
    "pre-commit": "^1.2.2",
    "proxyquire": "^2.1.3",
    "pump": "^3.0.0",
    "rimraf": "^3.0.2",
    "semver": "^7.0.0",
    "split2": "^4.0.0",
    "steed": "^1.1.3",
    "strip-ansi": "^6.0.0",
    "tap": "^16.0.0",
    "tape": "^5.0.0",
    "through2": "^4.0.0",
    "ts-node": "^10.7.0",
    "tsd": "^0.20.0",
    "typescript": "^4.4.4",
    "winston": "^3.3.3"
  },
  "dependencies": {
    "atomic-sleep": "^1.0.0",
    "fast-redact": "^3.0.0",
    "on-exit-leak-free": "^0.2.0",
    "pino-abstract-transport": "v0.5.0",
    "pino-std-serializers": "^4.0.0",
    "process-warning": "^1.0.0",
    "quick-format-unescaped": "^4.0.3",
    "real-require": "^0.1.0",
    "safe-stable-stringify": "^2.1.0",
    "sonic-boom": "^2.2.1",
    "thread-stream": "^0.15.1"
  },
  "tsd": {
    "directory": "test/types"
  }
}
